$(document).on('turbo:load', () => {
  
  $('#user_insurance_information_member_first_name, #user_insurance_information_member_last_name, #user_insurance_information_member_member_type, #user_insurance_information_member_sex, .user-insurance-information-dob-container .date-month-field, .user-insurance-information-dob-container .date-day-field, .user-insurance-information-dob-container .date-year-field, #user_insurance_information_member_lives_at_same_address_as_policyholder_true, #user_insurance_information_member_lives_at_same_address_as_policyholder_false').on("change keyup", (event) => {
    // validate the form for disabling the button
    if (
      $('#user_insurance_information_member_first_name').val().length > 0
      && $('#user_insurance_information_member_last_name').val().length > 0
      && $('#user_insurance_information_member_member_type').val() !== null
      && $('#user_insurance_information_member_sex').val().length !== null
      && $('.user-insurance-information-dob-container .date-month-field').val().length > 0
      && $('.user-insurance-information-dob-container .date-day-field').val().length > 0
      && $('.user-insurance-information-dob-container .date-year-field').val().length > 0
      && ($('#user_insurance_information_member_lives_at_same_address_as_policyholder_true').is(":checked") || $('#user_insurance_information_member_lives_at_same_address_as_policyholder').val() == "true")
    ) {
      $('#uiim-add-member-btn').prop("disabled", false);
    } else {
      $('#uiim-add-member-btn').prop("disabled", true);
    }
  });

  $('#user_insurance_information_member_lives_at_same_address_as_policyholder_true, #user_insurance_information_member_lives_at_same_address_as_policyholder_false').on('change', (event) => {
    if ($('#user_insurance_information_member_lives_at_same_address_as_policyholder_false').is(':checked')) {
      $('#member-same-address-message-container').show();
    } else {
      $('#member-same-address-message-container').hide();
    }
  });

  $('.user-insurance-information-dob-container #dob-month-field, .user-insurance-information-dob-container #dob-day-field, .user-insurance-information-dob-container #dob-year-field').on("change keyup", (event) => {
    $('#user_insurance_information_member_date_of_birth').val($('#dob-month-field').val() + "/" + $('#dob-day-field').val() + "/" + $('#dob-year-field').val());
  });
});